import React, { Component } from 'react';
import { DragSource, DropTarget } from 'react-dnd';
import { findDOMNode } from "react-dom";
import { ItemTypes } from './ItemTypes';

const spec = {
    beginDrag(props, monitor, component) {
        // 这里 return 出去的对象属性自行选择
        return {
            index: props.index,
            type: ItemTypes.ITEM,
        };
    },

    endDrag(props, monitor, component) {
    },

    canDrag(props, monitor) {
        let canDrag = props?.children?.props?.item?.islock;
        return !canDrag;
    },

};
const collect = (connect, monitor) => ({
    // 这里返回一个对象，会将对象的属性都赋到组件的 props 中去。这些属性需要自己定义。
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
    // result: monitor.getDropResult(),
    // itemType: monitor.getItemType(),
    // item: monitor.getItem(),
    // dropResult: monitor.getDropResult(),
    // didDrop: monitor.didDrop(),
    // initialClientOffset: monitor.getInitialClientOffset(),
    // initialSourceClientOffset: monitor.getInitialSourceClientOffset(),
    // clientOffset: monitor.getClientOffset(),
    // differenceFromInitialOffset: monitor.getDifferenceFromInitialOffset(),
    // sourceClientOffset: monitor.getSourceClientOffset(),
});

const targetSpec = {
    drop(props, monitor, component) {
        const dragItem = monitor.getItem();
        if (dragItem.type === "item") {
            //释放的分组对象
            props.moveItem(dragItem.index, props.index);
        }
    },

    hover(props, monitor, component) {
        let canDrop = props?.children?.props?.item?.islock;
        if(canDrop) {return;}
        const dragItem = monitor.getItem();
        if (dragItem.type === "item") {
            // hover到Item，根据是否超过hover Item高度的一半来判断是否需要重新排序
            const dragIndex = monitor.getItem().index;
            const hoverIndex = props.index;

            if (dragIndex === hoverIndex) {
                return;
            }
            const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();

            const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

            const clientOffset = monitor.getClientOffset();

            const hoverClientY = clientOffset.y - hoverBoundingRect.top;

            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return;
            }

            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return;
            }

            props.moveItem(dragIndex, hoverIndex);

            monitor.getItem().index = hoverIndex;
        }
    },

    canDrop(props, monitor) {
        let canDrop = props?.children?.props?.item?.islock;
        return !canDrop;
    },
};

const targetCollect = (connect, monitor) => ({
    // 这里返回一个对象，会将对象的属性都赋到组件的 props 中去。这些属性需要自己定义。
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
});
@DropTarget(ItemTypes.ITEM, targetSpec, targetCollect)
@DragSource(ItemTypes.ITEM, spec, collect)
class Item extends Component {
    render() {
        const {
            connectDragSource,
            connectDropTarget,
            isDragging,
        } = this.props;
        let boxShadow = {
            backgroundColor: '#fff',
            boxShadow: '0px 0px 4px 1px rgba(88, 146, 201, 0.36)',
        };
        let opacity = isDragging ? 0.8 : 1;
        let newBoxShadow = isDragging ? boxShadow : {};
        
        return (
            <>
                {connectDropTarget(
                    connectDragSource(
                        <div
                            className="setting-dnd-item"
                            style={{
                                opacity,
                                ...newBoxShadow,
                            }}
                        >
                            {this.props.children}
                        </div>,
                    ),
                )}
            </>
        );
    }
}
export default Item;